import { graphql } from "relay-runtime"

const deCallButtonQuery = graphql`
  query deCallButtonQuery($id: ID!) {
    callLineInformation: de_callLineInformationByPatientId(id: $id) {
      callLine
      isRecorded
    }
  }
`

export { deCallButtonQuery }
